<template>
  <div>
    <!-- 中止 -->
    <Modal v-model="show" :closable="false" :mask-closable="false" width="900" title="请单位线下提交以下材料">
      <Alert type="warning" show-icon>请带上原件及复印件！</Alert>
      <Form ref="suspendDataForm" :model="model" :rules="rules">
        <table class="table_flower" style="width:100%;margin-top:10px;">
          <tr>
            <th width="38%">材料类别</th>
            <th>材料名称</th>
            <!-- <th><i class="required" />是否检验原件</th> -->
            <!-- <th width="15%">提交的材料</th> -->
            <!-- <th width="15%">市网分数</th> -->
          </tr>
          <tbody v-for="(materialState,index) in model.materialStateInfoList" :key="index">
            <tr v-for="(list,i) in materialState.materialStateList" :key="i">
              <td v-if="i==0" :rowspan="materialState.materialStateList.length">{{materialState.category}}</td>
              <td>
                {{list.materialName}}

              </td>

            </tr>

          </tbody>
          <tr>
            <td>备注</td>
            <td>{{ model.offlineSubmitMaterialsRemark }}</td>
          </tr>
        </table>

      </Form>
      <Spin size="large" fix v-if="loading"></Spin>

      <template #footer>
        <Button @click="close" type="primary">确定</Button>
      </template>
    </Modal>
  </div>
</template>
<script>
import '../../residencePermitIntegral/styles/points.less'
export default {
  props: {
    show: Boolean,
    model: Object,
    loading: Boolean,
  },
  data() {
    return {
      selectList: [
        { name: '是', value: true },
        { name: '否', value: false },
      ],
      allCheckboxVal: false,
      rules: {},
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    copyVal(value) {
      let result
      let textarea = document.createElement('textarea')
      textarea.value = value
      textarea.readOnly = 'readOnly'
      document.body.appendChild(textarea)
      textarea.select() // 选中文本内容
      textarea.setSelectionRange(0, value.length)
      //提示
      this.$Message.success({
        content: '复制成功',
        duration: 8,
        background: true,
      })
      result = document.execCommand('copy')
      textarea.remove()
    },
    allCheckbox(val) {
      console.log('🚀 ~ allCheckbox ~ val:', val)
      this.$emit('allCheckbox', val)
    },
    confirm() {
      let _this = this
      this.$refs['suspendDataForm'].validate(async (valid) => {
        if (valid) {
          this.$emit('confirm')
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
/deep/.ivu-modal-body {
  padding: 16px;
  font-size: 14px;
  line-height: 1.5;
  max-height: 650px;
  overflow: auto;
}
/deep/.ivu-form-item {
  margin: 0px;
}
/deep/.ivu-form-item-error {
  margin-bottom: 20px;
}
.required::after {
  color: #ed4014;
  content: '*';
  display: inline-block;
  margin-right: 4px;
  line-height: 1;
  font-size: 14px;
}
/deep/.ivu-alert-message {
  font-weight: bold;
}
/deep/.ivu-alert-icon {
  top: 7px;
}
</style>